// MODULES
import React from "react";

import {createClassName} from "@helpers/utils";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import EditableField from "../../../components/EditableField/EditableField";
import OptionsList from "../../../components/OptionsList/OptionsList";
import fulfillmentCheck from "./Autogiro.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import NumberField from "../../../components/NumberField/NumberField";
import AbstractAutogiro from "../AbstractAutogiro";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import Select from "../../../../../components/Select/Select";
import Validator from "../../../../../classes/Validator";

export default class Autogiro extends AbstractAutogiro {

	static minimumAmountSingleDeposit = 1;
	static minimumAmountMonthlyDeposit = 2000;

	static maxNumberOfSelectableProducts = 4;
	static productLabel = "Portfölj";

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state, props} = this;
		const {availableBanks} = props;
		const {fields, validFields} = state;

		const classes = createClassName("Cob-Autogiro-AuAg", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClasses = createClassName("description", {
			"contractable": true,
			"expanded": state.textFieldExpanded
		});

		const textClassSingle = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_single.checked
		});

		const textClassMonthly = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_monthly.checked
		});

		const isInvalidSingleDepositShareDistribution = state.fields.customer_autogiro_single_amount >= Autogiro.minimumAmountSingleDeposit &&
			(state.autogiroSingleFundsSharesTotal < 100 ||
				state.autogiroSingleFundsSharesTotal > 100);

		const isInvalidMonthlyDepositShareDistribution = state.fields.customer_autogiro_monthly_amount >= Autogiro.minimumAmountMonthlyDeposit &&
			(state.autogiroMonthlyFundsSharesTotal < 100 ||
				state.autogiroMonthlyFundsSharesTotal > 100);

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (state.fields.customer_account_bank && state.fields.customer_account_bank.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === state.fields.customer_account_bank) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && state.fields.customer_account_bank === '-') {
				selectedBankIndex++;
			}
		}

		return (
			<div className={classes}>
				<h2 style={{
					marginBottom: "10px"
				}}>Förvaltningsstrategier/mandat</h2>

				<p style={{
					marginTop: "10px"
				}}>
					Välj en eller flera inriktningar för ditt sparande.
				</p>

				<div className="products">
					{state.products.map((product, index) => {
						const checked = this.state.fields.customer_products_selected.includes(product.label);

						return (
							<div className="row" key={index}>
								<CheckboxWithName
									label={product.label}
									name={product.label}
									value={checked ? "yes" : "no"}
									checked={checked}
									onChange={this._onProductCheck}
								/>

								<div className="fees">
									<Checkbox
										className="Cob-OptionsList-Option"
										type="radio"
										label={state.fields.fee_options[1].label}
										value={product.label}
										disabled={!checked}
										checked={this.state.fields.customer_fixed_fee_products.includes(product.label)}
										onChange={this._onSetFixedFee}
									/>
									<Checkbox
										className="Cob-OptionsList-Option"
										type="radio"
										label={state.fields.fee_options[0].label}
										value={product.label}
										disabled={!checked}
										checked={this.state.fields.customer_variable_fee_products.includes(product.label)}
										onChange={this._onSetVariableFee}
									/>
								</div>
							</div>
						);
					})}
				</div>

				<p style={{margin: "0"}}>
					Fast avgift 19 kr/mån, vid flera depåer maximalt 29 kr/mån per kund.<br/>
					Observera att depåavgiften påverkar den totala avgiften vid mindre belopp
				</p>

				<DefaultFields fields={this.constructor.fields}/>

				<p style={{margin: "20px 0px 10px 0"}}>
					För att du ska kunna sätta in och ta ut pengar, samt månadsspara via Autogiro måste nedanstående
					Autogiromedgivande fyllas i:
				</p>

				<div className={textClasses}>
					<strong>
						Autogiromedgivande / Föranmält konto
					</strong>
					<p>
						Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller
						av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning till
						denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag från
						angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren. Betalaren
						samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
						betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
						betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
						Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens betaltjänstleverantör,
						betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
						helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
						betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
						samband med betalningar kan finnas i villkoren för kontot och i avtalet med
						betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
						tjänsten i sin helhet avslutas.
					</p>
					<div className="expand">
						<div className="first"/>
						<div className="second"/>
						<div className="third" onClick={this._onExpandText}>Expandera texten</div>
					</div>
					<div className="contract" onClick={this._onExpandText}>
						Minimera texten
					</div>
				</div>

				<FieldsCollection
					fields={[
						{
							render: (
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="customer_autogiro"
									description="Jag ger mitt medgivande till betalning via autogiro"
									options={state.fields.customer_autogiro.options}
									onChange={this._onChangeAutogiroSelect}
								/>
							)
						}
					]}
				/>

				{!!state.fields.customer_autogiro.options[0].checked && (
					<React.Fragment>
						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<Select
								name="customer_account_bank"
								label="Bank"
								style={{width: "45%", marginRight: "10px"}}
								selectedIndex={selectedBankIndex}
								options={availableBankOptions}
								onChange={this._onSelectBankChange}
							/>

							{fields.customer_account_bank === '-' && (
								<React.Fragment>
									<EditableField
										name="customer_account_bank_custom"
										label="Bankens namn"
										style={{width: "45%"}}
										value={fields.customer_account_bank_custom || ""}
										valid={validFields.customer_account_bank_custom}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
									/>
									<input type="hidden" name="customer_account_bank"
										   value={fields.customer_account_bank_custom}/>
								</React.Fragment>
							)}

							{fields.customer_account_bank !== '-' && (
								<input type="hidden" name="customer_account_bank_custom" value=""/>
							)}
						</div>

						{fields.customer_account_bank === 'Swedbank' && (
							<p style={{background: "#FFFFD5", padding: "10px", fontSize: "12px", margin: "10px 0", maxWidth: "600px"}}>
								Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
								enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
							</p>
						)}

						<div style={{width: "100%", flexDirection: "row", margin: "5px 0"}}>
							<EditableField
								name="customer_account_bank_clearingno"
								style={{width: "45%", marginRight: "10px"}}
								label="Clearingnummer"
								value={fields.customer_account_bank_clearingno || ""}
								valid={validFields.customer_account_bank_clearingno}
								onChange={this._onClearingFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<EditableField
								name="customer_account_bank_no"
								style={{width: "45%"}}
								label="Kontonummer"
								value={fields.customer_account_bank_no || ""}
								valid={validFields.customer_account_bank_no}
								onChange={this._onAccountFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<input type="hidden" name="customer_account_clearing_no" value={fields.customer_account_bank_clearingno || ""} />
						</div>

						<div className="payments">
							<CheckboxWithName
								label="Jag vill göra en engånginsättning via Autogiro till följande förvaltningsstrategier/mandat"
								name="checkbox_autogiro_single"
								value={(state.fields.customer_autogiro.options[0].checked && state.fields.checkbox_autogiro_single.checked) ? "yes" : "no"}
								checked={state.fields.checkbox_autogiro_single.checked}
								disabled={state.fields.customer_products_selected.length === 0}
								onChange={this._onCheckboxChange}
							/>

							<div className={textClassSingle}>
								<div className="inner">
									<div className="funds">
										<div className="amountField">
											<EditableField
												name="customer_autogiro_single_amount"
												label="Belopp"
												className="amount"
												Component={NumberField}
												value={state.fields.customer_autogiro_single_amount || ""}
												valid={state.validFields.customer_autogiro_single_amount && state.fields.customer_autogiro_single_amount >= Autogiro.minimumAmountSingleDeposit}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
											/>
										</div>

										{state.fields.customer_products_selected.map((product, index) => {

											const depositAmount = state.fields.customer_autogiro_single_amount || 0;
											let fundAmount = 0;
											if (depositAmount > 0) {
												fundAmount = depositAmount * (this._getProductSingleShare(product) / 100);
												fundAmount = Math.round(fundAmount * 100) / 100;
											}
											let fundAmountForDisplay;
											if (fundAmount >= 0) {
												fundAmountForDisplay = fundAmount.toLocaleString("sv-SE", {minimumFractionDigits: 0}) + " SEK";
											}
											else {
												fundAmountForDisplay = "Felaktigt belopp";
											}

											return (
												<div className="product_row" key={index}>
													<div className="name">{product}</div>
													<input type="hidden"
														   name={"advice_asset_single_name_" + (index + 1)}
														   value={product}/>

													<div className="share">
														<EditableField
															name={product}
															label="Andel"
															Component={NumberField}
															unit="%"
															value={this._getProductSingleShare(product)}
															valid={!isInvalidSingleDepositShareDistribution}
															onChange={this._onPercentageSingleFieldChange}
															onBlur={this._onFieldBlur}
														/>

														<input type="hidden"
															   name={"advice_asset_single_share_" + (index + 1)}
															   value={this._getProductSingleShare(product)}/>
													</div>

													<div className="amount">{fundAmountForDisplay}</div>
												</div>
											);
										})}

										{isInvalidSingleDepositShareDistribution && (
											<div className="warning">
												<strong>Var god åtgärda:</strong> Summan av fördelningen måste vara
												100% (just nu {state.autogiroSingleFundsSharesTotal}%).
											</div>
										)}
									</div>
								</div>
							</div>

							<CheckboxWithName
								label={"Jag vill starta ett månadssparande via Autogiro till följande förvaltningsstrategier/mandat"}
								name="checkbox_autogiro_monthly"
								value={(state.fields.customer_autogiro.options[0].checked && state.fields.checkbox_autogiro_monthly.checked) ? "yes" : "no"}
								checked={state.fields.checkbox_autogiro_monthly.checked}
								disabled={state.fields.customer_products_selected.length === 0}
								onChange={this._onCheckboxChange}
							/>

							<div className={textClassMonthly}>
								<div className="inner">
									<div className="funds">
										<div className="amountField">
											<EditableField
												name="customer_autogiro_monthly_amount"
												label="Belopp"
												className="amount"
												Component={NumberField}
												value={state.fields.customer_autogiro_monthly_amount || ""}
												valid={state.validFields.customer_autogiro_monthly_amount && state.fields.customer_autogiro_monthly_amount >= Autogiro.minimumAmountMonthlyDeposit}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
											/>
											<span>(min. {Autogiro.minimumAmountMonthlyDeposit.toLocaleString("sv-SE", {minimumFractionDigits: 0})} SEK totalt. Fördela fritt mellan förvaltningsstrategierna/mandaten.)</span>
										</div>

										{state.fields.customer_products_selected.map((product, index) => {

											const depositAmount = state.fields.customer_autogiro_monthly_amount || 0;
											let fundAmount = 0;
											if (depositAmount > 0) {
												fundAmount = depositAmount * (this._getProductMonthlyShare(product) / 100);
												fundAmount = Math.round(fundAmount * 100) / 100;
											}
											let fundAmountForDisplay;
											if (fundAmount >= 0) {
												fundAmountForDisplay = fundAmount.toLocaleString("sv-SE", {minimumFractionDigits: 0}) + " SEK";
											}
											else {
												fundAmountForDisplay = "Felaktigt belopp";
											}

											return (
												<div className="product_row" key={index}>
													<div className="name">{product}</div>
													<input type="hidden"
														   name={"advice_asset_monthly_name_" + (index + 1)}
														   value={product}/>

													<div className="share">
														<EditableField
															name={product}
															label="Andel"
															Component={NumberField}
															unit="%"
															value={this._getProductMonthlyShare(product)}
															valid={!isInvalidMonthlyDepositShareDistribution}
															onChange={this._onPercentageMonthlyFieldChange}
															onBlur={this._onFieldBlur}
														/>

														<input type="hidden"
															   name={"advice_asset_monthly_share_" + (index + 1)}
															   value={this._getProductMonthlyShare(product)}/>
													</div>

													<div className="amount">{fundAmountForDisplay}</div>
												</div>
											);
										})}

										{isInvalidMonthlyDepositShareDistribution && (
											<div className="warning">
												<strong>Var god åtgärda:</strong> Summan av fördelningen måste vara
												100% (just nu {state.autogiroMonthlyFundsSharesTotal}%).
											</div>
										)}
									</div>
								</div>
							</div>

						</div>
					</React.Fragment>
				)}

				{
					/**
					 * In case we don't allow autogiro we make sure to fill out the first form with the selected products
					 * anyway, or otherwise these won't be visible in the final documentation (and no accounts will
					 * be created). Also, show a descip
					 **/
				}
				{!!state.fields.customer_autogiro.options[1].checked && (
					<React.Fragment>
						<p style={{
							fontStyle: "italic"
						}}>
							Överföring kan göras via insättning till Bankgiro. Instruktion kommer till din mail i
							välkomstbrevet.
						</p>

						{state.fields.customer_products_selected.map((product, index) => {
							return (
								<React.Fragment key={index}>
									<input type="hidden"
										   name={"advice_asset_single_name_" + (index + 1)}
										   value={product}/>
								</React.Fragment>
							);
						})}
					</React.Fragment>
				)}

			</div>
		);
	}

	_onSelectBankChange = (option) => {
		CobHelpers.onViewFieldChange.call(this, "customer_account_bank", option.value);
	};

	_onProductCheck = (name, checked) => {
		let productsArray = this.state.fields.customer_products_selected;
		let fixedFee = this.state.fields.customer_fixed_fee_products;

		let singleDepositProducts = this.state.fields.customer_single_deposit_products;
		let monthlyDepositProducts = this.state.fields.customer_monthly_deposit_products;

		// Remove the checkbox for variable fee for the product (since this is not the default option it should always go
		const variableFee = this.state.fields.customer_variable_fee_products.filter(function (value, index, arr) {
			return value !== name;
		});

		if (productsArray.includes(name)) { // Unchecking
			productsArray = productsArray.filter(function (value, index, arr) {
				return value !== name;
			});

			// Since we are unchecking the product we remove it from the fixed fee products array
			fixedFee = fixedFee.filter(function (value, index, arr) {
				return value !== name;
			});

			const newSingleDepositProducts = [];
			for (let i = 0; i < singleDepositProducts.length; i++) {
				if (singleDepositProducts[i].name !== name) {
					newSingleDepositProducts.push(singleDepositProducts[i]);
				}
			}
			singleDepositProducts = newSingleDepositProducts;

			const newMonthlyDepositProducts = [];
			for (let i = 0; i < monthlyDepositProducts.length; i++) {
				if (monthlyDepositProducts[i].name !== name) {
					newMonthlyDepositProducts.push(monthlyDepositProducts[i]);
				}
			}
			monthlyDepositProducts = newMonthlyDepositProducts;
		}
		else {
			productsArray.push(name);
			fixedFee.push(name); // Fixed fee is the default option

			singleDepositProducts.push({
				"name": name,
				"share": ""
			});

			monthlyDepositProducts.push({
				"name": name,
				"share": ""
			});
		}

		this.setState({
			fields: {
				...this.state.fields,
				customer_products_selected: productsArray,
				customer_variable_fee_products: variableFee,
				customer_fixed_fee_products: fixedFee,
				customer_single_deposit_products: singleDepositProducts,
				customer_monthly_deposit_products: monthlyDepositProducts
			},
			autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal("single", singleDepositProducts),
			autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal("monthly", monthlyDepositProducts)
		});
	};

	_onSetVariableFee = (checked, name) => {
		const variableFee = this.state.fields.customer_variable_fee_products;
		variableFee.push(name);

		const fixedFee = this.state.fields.customer_fixed_fee_products.filter(function (value, index, arr) {
			return value !== name;
		});

		this.setState({
			fields: {
				...this.state.fields,
				customer_variable_fee_products: variableFee,
				customer_fixed_fee_products: fixedFee
			}
		});
	};

	_onSetFixedFee = (checked, name) => {
		const fixedFee = this.state.fields.customer_fixed_fee_products;
		fixedFee.push(name);

		const variableFee = this.state.fields.customer_variable_fee_products.filter(function (value, index, arr) {
			return value !== name;
		});

		this.setState({
			fields: {
				...this.state.fields,
				customer_variable_fee_products: variableFee,
				customer_fixed_fee_products: fixedFee
			}
		});
	};

	_onExpandText = () => {
		this.setState({
			textFieldExpanded: !this.state.textFieldExpanded
		});
	};

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.state.fields.customer_account_bank === '-') ?
			true :
			Validator.validateClearingNumber(value, this.state.fields.customer_account_bank, this.props.availableBanks);

		CobHelpers.onViewFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if ((name === 'customer_autogiro_single_amount' || name === 'customer_autogiro_monthly_amount') && value === "0") {
			value = "";
		}

		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			},
			autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal("single", null),
			autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal("monthly", null)
		});
	};

	_onPercentageSingleFieldChange = (name, value) => {
		let singleDepositProducts = this.state.fields.customer_single_deposit_products;
		for (let i = 0; i < singleDepositProducts.length; i++) {
			if (singleDepositProducts[i].name === name) {
				singleDepositProducts[i].share = value;
			}
		}

		this.setState({
			fields: {
				...this.state.fields,
				customer_single_deposit_products: singleDepositProducts
			},
			autogiroSingleFundsSharesTotal: this._calculateFundsPercentagesTotal("single", singleDepositProducts)
		});
	};

	_onPercentageMonthlyFieldChange = (name, value) => {
		let monthlyDepositProducts = this.state.fields.customer_monthly_deposit_products;
		for (let i = 0; i < monthlyDepositProducts.length; i++) {
			if (monthlyDepositProducts[i].name === name) {
				monthlyDepositProducts[i].share = value;
			}
		}

		this.setState({
			fields: {
				...this.state.fields,
				customer_monthly_deposit_products: monthlyDepositProducts
			},
			autogiroMonthlyFundsSharesTotal: this._calculateFundsPercentagesTotal("monthly", monthlyDepositProducts)
		});
	};

	_getProductSingleShare(name) {
		let singleDepositProducts = this.state.fields.customer_single_deposit_products;
		for (let i = 0; i < singleDepositProducts.length; i++) {
			if (singleDepositProducts[i].name === name) {
				return singleDepositProducts[i].share;
			}
		}

		return "";
	}

	_getProductMonthlyShare(name) {
		let monthlyDepositProducts = this.state.fields.customer_monthly_deposit_products;
		for (let i = 0; i < monthlyDepositProducts.length; i++) {
			if (monthlyDepositProducts[i].name === name) {
				return monthlyDepositProducts[i].share;
			}
		}

		return "";
	}

	_calculateFundsPercentagesTotal(type, products) {
		if (products == null) {
			products = (type === "single") ? this.state.fields.customer_single_deposit_products : this.state.fields.customer_monthly_deposit_products;
		}

		let total = 0;
		for (let i = 0; i < products.length; i++) {
			const productShare = parseInt(products[i].share, 10);
			if (!isNaN(productShare)) {
				total += productShare;
			}
		}

		return total;
	}

	_onFieldBlur = (name) => {
		if (name === 'customer_account_bank_clearingno') {
			CobHelpers.onViewFieldBlur.call(this, name, null, true);
		}
		else {
			CobHelpers.onViewFieldBlur.call(this, name);
		}
	};

	_fieldValidator = (name, value) => {
		if (name === 'customer_account_bank_no') {
			return this._isValidBankAccountNo(false, value, this.state.fields.customer_autogiro_bank_clearingno);
		}
		return value.length > 0;
	};

	_onChangeAutogiroSelect = ({type, name}, option, index) => {
		name = name || option.name;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});


		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"customer_account_bank",
		"customer_account_bank_custom",
		"customer_account_bank_no",
		"customer_account_bank_clearingno",
		"customer_autogiro",

		"checkbox_autogiro_single",
		"customer_autogiro_single_amount",

		"checkbox_autogiro_monthly",
		"customer_autogiro_monthly_amount"
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	return {
		textFieldExpanded: false,
		autogiroOneTimeDepositProductsActive: 1,
		autogiroSingleFundsSharesTotal: 0,
		autogiroMonthlyFundsActive: 1,
		autogiroMonthlyFundsSharesTotal: 0,
		products: [],

		fields: {
			"customer_products_selected": [],
			"customer_variable_fee_products": [],
			"customer_fixed_fee_products": [],
			"customer_single_deposit_products": [],
			"customer_monthly_deposit_products": [],
			"fee_options": [
				{label: "Rörlig avgift", value: "rorlig"},
				{label: "Fast avgift", value: "fast"}
			],

			"customer_account_bank": "",
			"customer_account_bank_custom": "",
			"customer_account_bank_no": "",
			"customer_account_bank_clearingno": "",
			"customer_autogiro": {
				options: [
					{label: "Ja", value: "yes"},
					{label: "Nej", value: "no"}
				]
			},

			"checkbox_autogiro_single": {
				checked: false
			},
			"checkbox_autogiro_monthly": {
				checked: false
			}
		},
		validFields: {}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/auagfonder/Autogiro.js